import store from "./../store";
// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE)
import "@/polyfills";
// Notifications plugin. Used on Notifications page
import Notifications from "@/components/NotificationPlugin";
// Validation plugin used to validate forms
import { configure } from "vee-validate";
// A plugin file where you could register global components used across the app
import GlobalComponents from "./globalComponents";
// A plugin file where you could register global directives
import GlobalDirectives from "./globalDirectives";
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from "@/components/SidebarPlugin";

// element ui language configuration
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
locale.use(lang);

// vue-bootstrap
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// asset imports
import "@/assets/scss/argon.scss";
import "@/assets/vendor/nucleo/css/nucleo.css";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import { messages } from "vee-validate/dist/locale/en.json";

/**
 * IDBRICS
 */
// Notiflix
import notiflix from "notiflix";
// font-awesome
import "@/assets/css/ftaws.css";
// vue-good-tables
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
// api setup
import api from "./api.js";

// Socketio
import * as io from "socket.io-client";
import VueSocketIO from "vue-socket.io";
const options_io = { path: "/socket.io/" };

import PrettyCheckbox from "pretty-checkbox-vue";
import "pretty-checkbox/src/pretty-checkbox.scss";

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule], // assign message
  });
});

export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(SideBar);
    Vue.use(Notifications);
    Vue.use(BootstrapVue);
    Vue.use(IconsPlugin);
    configure({
      classes: {
        valid: "is-valid",
        invalid: "is-invalid",
        dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
      },
    });

    Vue.use(VueGoodTablePlugin);
    Vue.use(PrettyCheckbox);
    Vue.prototype.$notiflix = notiflix;
    Vue.prototype.$api = api;
    Vue.prototype.$backend = process.env.VUE_APP_BACKEND;
    // Vue.use(
    //   new VueSocketIO({
    //     debug: true,
    //     connection: io(`https://${window.location.hostname}:5000`),
    //     vuex: {
    //       store,
    //       actionPrefix: 'SOCKET_',
    //       mutationPrefix: 'SOCKET_'
    //     },
    //   })
    // );
  },
};
